import { UserRoles } from '@/enums';
import { Subpartners } from '@/modules/subpartners/types';
import { all_internal_roles } from '@/utils';

const access_roles = {
  [Subpartners.Pages.SUBPARTNERS]: all_internal_roles,
  [Subpartners.Pages.SUBPARTNER_DETAIL]: all_internal_roles,
  [Subpartners.Pages.SUBPARTNER_EDIT]: all_internal_roles,
  [Subpartners.Pages.SUBPARTNERS_SALES]: [
    UserRoles.Internal.PARTNER_MANAGER, UserRoles.Internal.VICE_PARTNER_MANAGER,
  ],
};

export default access_roles;
